import { neutralColors } from '@styles/design-system';
import { formatMoney } from '@utils/currency';
import React from 'react';

/** Cells the Sales Orders list and the order detail page both draw. */

export const TwoLine: React.FC<{ primary: React.ReactNode; secondary?: React.ReactNode }> = ({ primary, secondary }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, lineHeight: 1.3 }}>
        <span>{primary}</span>
        {secondary ? <span style={{ fontSize: 11, color: neutralColors.textMuted }}>{secondary}</span> : null}
    </div>
);

const Dash: React.FC = () => <span style={{ color: neutralColors.textMuted }}>—</span>;

/**
 * A price or value stated before and after tax: before tax leads, with tax sits beneath.
 * A figure nobody stated is a dash, never zero. `note` replaces the with-tax line when
 * there is something more important to say about the figure (a partial total).
 */
export const MoneyPair: React.FC<{ beforeTax?: number | null; withTax?: number | null; withTaxLabel?: string; note?: string }> = ({
    beforeTax,
    withTax,
    withTaxLabel = 'with tax',
    note,
}) => {
    if (beforeTax === null || beforeTax === undefined) {
        return withTax === null || withTax === undefined ? <Dash /> : <TwoLine primary={<Dash />} secondary={`${formatMoney(withTax)} ${withTaxLabel}`} />;
    }
    const secondary = note ?? (withTax === null || withTax === undefined ? undefined : `${formatMoney(withTax)} ${withTaxLabel}`);
    return <TwoLine primary={<span style={{ fontVariantNumeric: 'tabular-nums' }}>{formatMoney(beforeTax)}</span>} secondary={secondary} />;
};
